const Label = ({ title, className }) => (
  <span className={`text-secondary font-medium text-sm ${className}`}>
    {title}
  </span>
);

export default Label;
